import apiBaseUrl from '../../utils/config.js';

class InsuranceDetailsService {
  constructor() {
    this.baseUrl = `${apiBaseUrl}/insurance`;
  }

  getToken() {
    return localStorage.getItem("jwt");
  }

  getAuthHeaders() {
    const token = this.getToken();
    return {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    };
  }

  async #request(endpoint, method = 'GET', body = null, expectText = false) {
    const options = {
      method,
      headers: this.getAuthHeaders(),
    };

    if (body) {
      options.body = JSON.stringify(body);
    }

    try {
      const response = await fetch(`${this.baseUrl}${endpoint}`, options);
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Request failed: ${errorText}`);
      }
      return expectText ? response.text() : response.json();
    } catch (error) {
      console.error(`Error during request to ${endpoint}:`, error);
      throw error;
    }
  }

  async getAllInsuranceDetails() {
    return this.#request('/all');
  }

  async getInsuranceDetailById(id) {
    return this.#request(`/${id}`);
  }

  async addInsuranceDetail(insuranceDetail) {
    return this.#request('/add', 'POST', insuranceDetail);
  }

  async updateInsuranceDetail(id, updatedDetail) {
    return this.#request(`/update/${id}`, 'PUT', updatedDetail);
  }

  async deleteInsuranceDetail(id) {
    return this.#request(`/delete/${id}`, 'DELETE');
  }

  async getInsuranceNameById(id) {
    const insName = await this.#request(`/name/${id}`, 'GET', null, true);
    const el = document.getElementById("insuranceNameDisplay");
    if (el) el.innerText = insName;
    return insName;
  }
}

export default InsuranceDetailsService;
